export default __webpack_public_path__ + "52ca4fe7b4236cbdebfde0e87432bca1.jpg";